export default {
    namespaced: true,

    state: {
        client: {},

        benefits: {},
        benefits_requested: false,

        affordability: {},

        age_range: {
            min: 17,
            max: 54,
        },

        departments: [],
        products: [],
        types: [],

        resources_loaded: false,

        kp_error: '',
    },

    getters: {
        getClient(state) {
            return state.client;
        },
        getBenefits(state) {
            return state.benefits;
        },
        getBenefitsRequested(state) {
            return state.benefits_requested;
        },
        getAffordability(state) {
            return state.affordability;
        },
        getAgeRange(state) {
            return state.age_range;
        },

        getDepartments(state) {
            return state.departments;
        },
        getProducts(state) {
            return state.products;
        },
        getTypes(state) {
            return state.types;
        },
        getKpError(state) {
            return state.kp_error;
        },

        getResourcesLoaded(state) {
            return state.resources_loaded;
        }
    },

    actions: {
        getResources(context) {
            return new Promise((resolve, reject) => {
                if (context.getters.getResourcesLoaded) {
                    resolve();
                    return false;
                }

                window.axios.post('/calculators/keyPlanResources')
                    .then((response) => {
                        context.commit('setDepartmentOptions', response.data.departments);
                        context.commit('setProductOptions', response.data.products);
                        context.commit('setTypeOptions', response.data.types);

                        context.commit('setResourcesLoaded', true);

                        resolve();
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error);
                    });
            });

        },
        newQuote(context) {
            const client = {
                product: null,
                employee_number: '',
                employer: null,
                department: null,
                age: 35,
                plan_type: null,
                retire_age: 60,
            };

            context.commit('setClient', client);
            context.commit('setBenefits', {});
            context.commit('setBenefitsRequested', false);
            context.commit('setAffordability', {});

            this.dispatch('calculators/resetAll');
        },

        getBenefits(context) {
            this.commit('calculators/setChecking', true);
            context.commit('setError', '');

            window.axios.post('/calculators/keyPlanBenefits', {
                plan: context.getters.getClient.product,
                age: context.getters.getClient.age,
            })
                .then((response) => {
                    if (typeof response.data.benefits !== 'undefined') {
                        context.commit('setBenefits', response.data.benefits);
                        context.commit('setBenefitsRequested', true);
                    }

                    if (typeof response.data.error !== 'undefined') {
                        context.commit('setError', response.data.error);
                    }

                    this.commit('calculators/setChecking', false);
                })
                .catch((error) => {
                    console.error(error);

                    this.commit('calculators/setChecking', false);
                });
        },
        getAffordability(context) {
            this.commit('calculators/setChecking', true);
            context.commit('setError', '');

            context.commit('setAffordability', {});

            window.axios.post('/calculators/keyPlanCalculate', {
                number: context.getters.getClient.employee_number.replace('-', ''),
                payroll: context.getters.getClient.type,
                amount: context.getters.getBenefits.keyplanPremium.value,
                age: context.getters.getClient.age,
                plan: context.getters.getClient.product,
                department: context.getters.getClient.department
            })
                .then((response) => {
                    if (typeof response.data.affordability !== 'undefined') {
                        context.commit('setAffordability', response.data.affordability);
                    }

                    if (typeof response.data.error !== 'undefined') {
                        context.commit('setError', response.data.error);
                    }

                    this.commit('calculators/setChecking', false);
                })
                .catch((error) => {
                    console.error(error);
                    this.commit('calculators/setChecking', false);
                });
        },
    },

    mutations: {
        setClient(state, client) {
            state.client = client;
        },
        setBenefits(state, benefits) {
            state.benefits = benefits;
        },
        setBenefitsRequested(state, boolean) {
            state.benefits_requested = boolean;
        },
        setAffordability(state, affordability) {
            state.affordability = affordability;
        },

        setMaxAge(state, max) {
            state.age_range.max = max;
        },
        setMinAge(state, min) {
            state.age_range.min = min;
        },

        setDepartmentOptions(state, options) {
            state.departments = options;
        },
        setProductOptions(state, options) {
            state.products = options;
        },
        setTypeOptions(state, options) {
            state.types = options;
        },

        setResourcesLoaded(state, boolean) {
            state.resources_loaded = boolean;
        },

        setError(state, error) {
            state.kp_error = error;
        }
    }
}
